import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkDnsDomainRenewParamsRaw,
	type LWApiPublicNetworkDnsDomainRenewResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/dns/domain/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { DOMAIN_LIST_QUERY_KEY } from 'modules/queries/domain/useList';
import { NETWORK_DNS_DOMAIN_REGISTRATION_DETAILS_QUERY_KEY } from './useRegistrationDetails';

const useDomainRenew = () => {
	const queryClient = useQueryClient();
	return useMutation<
		LWApiPublicNetworkDnsDomainRenewResultRaw,
		ApiErrorI,
		LWApiPublicNetworkDnsDomainRenewParamsRaw
	>({
		mutationFn: (params) => api.network.dns.domain.apiRaw.renew(params),

		onSuccess: (_data, params) => {
			toast.success(`Successfully renewed domain ${params.domain}`);

			// Invalidate domain list and registration details queries
			queryClient.invalidateQueries({
				queryKey: [DOMAIN_LIST_QUERY_KEY],
			});
			queryClient.invalidateQueries({
				queryKey: [NETWORK_DNS_DOMAIN_REGISTRATION_DETAILS_QUERY_KEY],
			});
		},

		onError: (_error) => {
			toast.danger(
				'Failed to renew domain. Please retry. If the error persists, please contact support.',
			);
		},
	});
};

export default useDomainRenew;
